import { useCallback, useEffect, useRef } from 'react';
import { Blocker, useBlocker } from 'react-router-dom';
import { UnsavedChangesType, useModalUnsavedChanges } from './use-modal-unsaved-changes';

const useCheckUnsavedChanges = (callback?: VoidFunction, onCancel?: VoidFunction): UnsavedChangesType => {
    const blockerRef = useRef<Blocker | null>(null);
    const afterConfirm = useCallback(() => blockerRef.current?.proceed?.(), []);
    const afterDismiss = useCallback(() => blockerRef.current?.reset?.(), []);

    const unsavedChanges = useModalUnsavedChanges(callback, onCancel, { afterConfirm, afterDismiss });
    const { shouldShowUnsavedChanges, showUnsavedChangesIfNeededOrClose } = unsavedChanges;

    const blocker = useBlocker(shouldShowUnsavedChanges());
    useEffect(() => {
        blockerRef.current = blocker;
    }, [blocker]);

    useEffect(() => {
        if (blocker.state === 'blocked') {
            showUnsavedChangesIfNeededOrClose();
        }
    }, [blocker.state, showUnsavedChangesIfNeededOrClose]);

    return unsavedChanges;
};

export default useCheckUnsavedChanges;
